import {
  Route,
  BrowserRouter as Router,
  Switch,
  Redirect,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { useEffect } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";

/** TRANSITION */
import "./i18n.js";

/** COMPONENT */
import { routeName } from './routes/routers-name';
import Login from './pages/auth/login';
import AppShell from './component/layout/AppShell';
import SessionGuard from './component/layout/SessionGuard';
import PageNotFound from './pages/pageNotFound/pageNotFound';
import { getPermissionMenus, getToken, logout, getBranch } from './utils/app.utils';

/**STYLE */
import { styled } from '@mui/material/styles'
import SelectBranches from "./pages/auth/selectBreanches";
import { Box, Typography } from "@mui/material";
import { colors } from "./constants/colors";

const ModalContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
}));

const MainRedText = styled(Typography)(({ theme }) => ({
  fontSize: 18,
  color: colors.red,
  textAlign: "center",
}));
const BlackText = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  color: colors.black,
}));
const ClickPayDebt = styled(Typography)(({ theme }) => ({
  fontSize: 16,
  color: colors.red,
  marginLeft: 4,
  ":hover": {
    textDecoration: "underline",
    cursor: "pointer"
  },
}));

export function App() {

  const token = getToken();
  const branch = getBranch()
  const currPath = window.location.href;
  const permissionMenus = getPermissionMenus()
  // const [profile, setProfile] = useState(true);
  const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID

  useEffect(() => {
    if (!token) {
      whoami();
    }
  }, [token]);

  const whoami = () => {
    if (!currPath.includes("login")) {
      window.location.href = routeName.login;
      return <Redirect to={routeName.login} />;
    } else if (currPath.includes("register")) {
      window.location.href = routeName.register;
      return <Redirect to={routeName.register} />;
    } else if (currPath.includes("select-branch")) {
      return <Redirect to={routeName.selectBranches} />;
    }
  };


  // const whoami = useCallback(() => {
  //   LoginApi.profile()
  //     .then(({ data }) => {
  //       setProfile(false)
  //       if (data) dispatch(editProfile({ value: data, key: 'selectProfile' }))
  //       else autoLogout()
  //     })
  //     .catch((e) => autoLogout())
  // }, [])

  // const autoLogout = () => {
  //   logout()
  //   if (!currPath.includes('login')) window.location.href = routeName.login
  //   return <Redirect to={routeName.login} />
  // }

  function PickRoute({ exact, path, key, component: Component }: any) {
    if (token && (!permissionMenus || !branch)) {
      return (
        <>
          <Route exact={exact} path={path} key={key} component={Component} />
          <Redirect to={path} />
        </>
      )
    } else {
      logout()
      return <Redirect to={routeName.login} />
    }
  }

  return (
    <>
      <GoogleOAuthProvider clientId={googleClientId || '423635009992-jste802enleki812ni57i4jf9bg9337k.apps.googleusercontent.com'}>
        <Router>
          {/* ต้องอยู่นอก <Switch> ไม่งั้น Switch จะนับเป็น child ที่ไม่มี path แล้ว match ทุก URL */}
          <SessionGuard />
          <Switch>
            {/* อยู่หลัง branch */}
            {/* || JSON.parse(atob(profile))?.roleId !== 2 */}
            {
              token && branch &&
              // token && (branch || JSON.parse(atob(profile))?.roleId !== 2) &&
              (
                /** route ของหน้าที่ล็อกอินแล้วทั้งหมดอยู่ใน Switch ชั้นในของ AppShell
                 *  ตัวนี้ไม่มี path จึงเป็น catch-all ของ Switch ชั้นนอกเหมือนที่ routes.map เคยครอบไว้ */
                <Route key="app-shell">
                  <AppShell />
                </Route>
              )
              ||
              <>
                <Route key="login" path={routeName.login} component={Login} />
                <PickRoute key="select-branch" path={routeName.selectBranches} component={SelectBranches} />
              </>
            }
            <Route key="PageNotFound" component={PageNotFound} />
          </Switch>
        </Router>
      </GoogleOAuthProvider>
      <ToastContainer enableMultiContainer />
    </>
  );
}
